import { FeFilterPresetsKind } from '@lib/enums/feFilterPresets';
import { MonitoringEntity } from '../enums';

export default function getFeFilterPresetKind(
  monitoringEntity: MonitoringEntity,
) {
  let kind: FeFilterPresetsKind | null = null;
  if (monitoringEntity === MonitoringEntity.Site) {
    kind = FeFilterPresetsKind.AdminSitePerformanceMonitoring;
  } else if (monitoringEntity === MonitoringEntity.Sector) {
    kind = FeFilterPresetsKind.AdminSectorPerformanceMonitoring;
  }
  return kind;
}
